export default class NumberUtils {
    static formatNumber = (value: any): number => {
        return Number(value.replace(/\./g, '').replace(',', '.')).toFixed(2) as any;
    };
}
